import RequireSuperAdminMiddleware from 'middlewares/RequireSuperAdminMiddleware'

const middlewares = [RequireSuperAdminMiddleware]

export default [
    {
        path: '/intelligence',
        name: 'intelligence',
        view: 'intelligence/Layout',
        redirect: { name: 'intelligence.overview' },
        middlewares,
        children: [
            {
                path: 'overview',
                name: 'intelligence.overview',
                view: 'intelligence/Overview',
            },
            {
                path: 'constraints',
                name: 'intelligence.constraints',
                view: 'intelligence/Constraints',
            },
            {
                path: 'delivery',
                name: 'intelligence.delivery',
                view: 'intelligence/Delivery',
            },
            {
                path: 'supply-demand',
                name: 'intelligence.supply-demand',
                view: 'intelligence/SupplyDemand',
            },
            {
                path: 'entitlement',
                name: 'intelligence.entitlement',
                view: 'intelligence/Entitlement',
            },
            {
                path: 'patient-friction',
                name: 'intelligence.patient-friction',
                view: 'intelligence/PatientFriction',
            },
            {
                path: 'provider-performance',
                name: 'intelligence.provider-performance',
                view: 'intelligence/ProviderPerformance',
            },
            {
                path: 'provider-competition',
                name: 'intelligence.provider-competition',
                view: 'intelligence/ProviderCompetition',
            },
        ],
    },
]
